import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveTagNotificationState = createStateReducer(initialState, {
  [events.removeTagSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeTag",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeTagFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeTag",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveTagNotificationState };
